export default {
  slideData: {},
  slideTimers: {},
  containerHeight: undefined,
  currentPage: 1,
  currentIteration: 1,
  timeoutRef: undefined,
};
